import {
  ControlledDatePicker
} from '@@viewCommonComponents/controlled';
import { isRequiredInput } from '@@viewHelpers/validations';
import { CustomerProfessionalStatusEnum } from '@fasstech/oip-core/entities/Customer/enums';
import { useWatch } from 'react-hook-form';

const SimulationCustomerGranteesExtraCompanyInformation = ({ form }) => {

  const customerProfessionalStatus = useWatch({
    control: form.control,
    name: 'customer.professionalStatus'
  });

  if (customerProfessionalStatus !== CustomerProfessionalStatusEnum.ENTREPRENEUR) {
    return null;
  }

  return (

    <ControlledDatePicker
      name="company.creationDate"
      label="Date de création de l’entreprise"
      data-testid="ADHERENT_COMPANY_CREATION_DATE"
      form={form}
      rules={isRequiredInput(true)}
    />

  );
};

export default SimulationCustomerGranteesExtraCompanyInformation;
